"use client"

import SRKR from "../Images/SRKREC.jpeg"
import Tirumala from "../Images/Tirumala.png"
import Sidd from "../Images/Sidd.png"

const Education = () => {
  const educationData = [
    {
      id: 1,
      institution: "SRKR Engineering College",
      degree: "Bachelor of Technology, E.C.E.",
      location: "Bhimavaram, AndhraPradesh",
      duration: "2021 - 2025",
      grade: "8.45 CGPA",
      description:
        "I pursued my Bachelor's degree in Electronics and Communication Engineering at SRKR Engineering College, Bhiamavaram. I serve as the President of PAIE Cell at SRKREC, where I've honed my communication and time management skills. Additionally, I hold the position of Vice President in the SRKR Student Council, where our primary focus is to ensure the well-being and enjoyment of all SRKREC students. We strive to provide support in their respective areas of interest and enhance their overall campus experience.",
      image: SRKR,
    },
    {
      id: 2,
      institution: "Tirumala Junior College",
      degree: "Board of Intermediate Education, M.P.C.",
      location: "Katheru, AndhraPradesh",
      duration: "2019 - 2021",
      grade: "96.7 % (A+ Grade)",
      description:
        "I pursued my intermediate education at Tirumala Junior College, Katheru, where I decided to specialize in mathematics, physics, and chemistry. During my time there, I developed strong problem-solving skills and gained confidence in tackling complex questions. I successfully achieved a remarkable score of 96.7% in the board examinations, showcasing my dedication and proficiency in the chosen subjects.",
      image: Tirumala,
    },
    {
      id: 3,
      institution: "Sri Siddartha EM High School",
      degree: "Board of Secondary Education, S.S.C.",
      location: "Ravulapalem, AndhraPradesh",
      duration: "2018 - 2019",
      grade: "9.8 CGPA",
      description:
        "I embarked on my academic journey at Sri Siddartha EM High School, where I remained committed from LKG to 10th grade. Throughout this period, I not only gained valuable knowledge in various subjects but also acquired insights into both educational and personal matters. The continuity of my education at the same school allowed me to build a strong foundation and foster a deep connection with my learning environment. This experience has significantly contributed to my holistic growth, shaping both my academic and personal perspectives.",
      image: Sidd,
    },
  ];

  return (
    <section className="min-h-screen bg-bg-secondary px-[9%] py-[10rem] relative" id="education">
      {/* Custom Shape Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-[calc(158%+1.3px)] h-[139px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M649.97 0L550.03 0 599.91 54.12 649.97 0z" className="fill-bg-primary"></path>
        </svg>
      </div>

      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex flex-col items-center w-full max-w-[1350px] pt-[40px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-5 text-white font-rowdies">
            Education
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            My educational journey has been a process of self-discovery and personal growth. Here are the details of my
            academic background.
          </p>

          {/* One-by-one cards */}
          <div className="w-full max-w-[700px] flex flex-col gap-8 mt-10">
            {educationData.map((edu) => (
              <div key={edu.id} className="w-full">
                <div className="w-full rounded-[10px] shadow-[rgba(219,216,216,0.15)_0px_8px_24px] p-[12px_16px] justify-between relative overflow-hidden flex flex-col gap-3 transition-all duration-300 border border-white hover:shadow-[0px_0px_20px_rgba(250,250,250,0.2)] hover:-translate-y-[5px] group">
                  <div className="w-full flex gap-3">
                    <img
                      src={edu.image || "/placeholder.svg"}
                      alt={edu.institution}
                      className="h-[50px] bg-white rounded-[10px] mt-1"
                    />
                    <div className="w-full flex flex-col">
                      <div className="text-[18px] font-semibold text-white">{edu.institution}</div>
                      <div className="text-[14px] font-medium text-white">{edu.degree}</div>
                      <div className="text-[14px] font-medium text-white">{edu.location}</div>
                      <div className="text-[14px] font-medium text-white">{edu.duration}</div>
                    </div>
                  </div>
                  <div className="text-[14px] font-medium text-white">
                    <strong>Grade: </strong>
                    {edu.grade}
                  </div>
                  <div className="text-[15px] font-normal text-white mb-[10px] overflow-hidden max-w-full line-clamp-4 text-ellipsis group-hover:line-clamp-none group-hover:overflow-visible">
                    {edu.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
